// MIRROR of trybe-mobile client/scripts/common/constants/communityConstants.js
// (the subset the dashboard needs). Keep values identical to mobile — posts written
// by the dashboard must be indistinguishable from posts written by the app.

// Community feeds are keyed by feedId to support future exclusive communities
// (e.g. feedId = oneTimeProductId). MVP ships only the org-wide 'main' feed.
export const MAIN_FEED_ID = 'main'

// How long a coach's pinned post stays pinned before dropping back into the
// timeline (same default the old announcements expiration used).
export const PIN_DURATION_MS = 30 * 24 * 60 * 60 * 1000

export const POST_MAX_LENGTH = 2000
export const REPLY_MAX_LENGTH = 1000

// Page size for the feed and the "Your posts" tab: each keeps a live listener on
// its newest DASHBOARD_POSTS_PAGE_SIZE posts, and "Load more" widens a second
// listener below that by this many at a time (see usePostPager).
export const DASHBOARD_POSTS_PAGE_SIZE = 100

export const AVATAR_COLORS = [
  '#4dba97', // trybe green
  '#5B8DEF',
  '#EC6F59',
  '#E5A54B',
  '#9B6FDE',
  '#4BB8D4',
  '#D46FA8',
  '#7A9E4E',
]
